import React, {Component, Fragment} from 'react'
import Doctor from './Doctor'
import pop from '../pop'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/fontawesome-free-solid";

export default class Doctors extends Component {

    handleButton = (e) => {
        const value = e.target.value.replace(/[^A-zÀ-ÿ0-9_ :(),]+/, '')
        this.props.handleIsAnnexeDisplay(value)
    }
 
    render() {
        const pops = pop
        const doctors = this.props.doctors
        const englishSelected = this.props.englishSelected
        const englishLanguage = this.props.englishLanguage
        const frenchLanguage = this.props.frenchLanguage
        const handleInformation = this.props.handleInformation
        const displayInformation = this.props.displayInformation
        const information = this.props.information

        const doctorsCards = Object.keys(doctors).map(key =>
            <Doctor key={key}
                details={doctors[key]} 
                englishLanguage={englishLanguage} 
                frenchLanguage={frenchLanguage}
                englishSelected={englishSelected}
            />)
        return (
            <main id="main" onLoad={pops}>
                <div id="banner"></div>
                {displayInformation &&
                    <div id="information">
                        <FontAwesomeIcon className="fa close__icon"  size="1x" icon={faTimes}  onClick={handleInformation}/>
                        <h2>{ englishSelected ? 'Attention' : 'Attention' }</h2>
                        {information.information1En ?   <p>{ englishSelected ? information.information1En : information.information1Fr }</p> :
                            <div className="centerLoadling">
                                <div id="loading" className="loading1"></div>
                                <div id="loading" className="loading2"></div>
                                <div id="loading" className="loading3"></div>
                            </div>
                        }
                        <p>{ englishSelected ? information.information2En : information.information2Fr }</p>
                        <p>{ englishSelected ? information.information3En : information.information3Fr }</p>
                        <p>{ englishSelected ? information.information4En : information.information4Fr }</p>
                    </div>
                }

                <div className="content mb150">
                    <Fragment>
                        <h1>{ englishSelected ? englishLanguage.mainTitle : frenchLanguage.mainTitle }</h1>
                        <p>{ englishSelected ? englishLanguage.mainParagraph1 : frenchLanguage.mainParagraph1 }</p>
                        <p>{ englishSelected ? englishLanguage.mainParagraph2 : frenchLanguage.mainParagraph2 }</p>
                        <p>{ englishSelected ? englishLanguage.mainParagraph3 : frenchLanguage.mainParagraph3 }</p>
                        <p>{ englishSelected ? englishLanguage.mainParagraph31 : frenchLanguage.mainParagraph31 } <a href="mailto:info@centre-medical-bonnevoie.lu">info@centre-medical-bonnevoie.lu</a></p>
                        <p>{ englishSelected ? englishLanguage.mainParagraph32 : frenchLanguage.mainParagraph32 }</p>
                        <p>{ englishSelected ? englishLanguage.mainParagraph4 : frenchLanguage.mainParagraph4 }</p>
                    </Fragment>
                </div>
                <div className="content mb150">
                    <h1>{englishSelected ? englishLanguage.doctorTitle : frenchLanguage.doctorTitle }</h1>

                    <div className="alt-content">
                    </div>

                    <div className="row doctors__row">
                        {doctorsCards}
                    </div>
                </div>
            </main>
        )
    }
}
